import { createSelector } from 'reselect';

export const MediaLibrarySelector = (state) => state.media_library;

export const getMediaLibrary = createSelector(
    [MediaLibrarySelector],
    (data) => {
        return {
            loading: data.loading,
            error: data.error,
            groups: data.groups,
            page: data.page,
            pageSize: data.pageSize,
            totalPages: data.totalPages,
            count: data.count,
            hasNext: data.hasNext,
            hasPrevious: data.hasPrevious
        };
    }
);
